/*
 * @Description:
 * @Author: xiaoyao
 * @since: 2018-12-29 17:34:06
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-28 11:18:37
 */
module.exports = {
  devhost: "0.0.0.0",
  // apiURL:"/api" //反向代理
  dev_api: "https://onlyuser-dev.cdqidian.net",
  dev_api2: "https://vitcustomer-dev.cdqidian.net",
  dev_api3: "https://vitcalc-dev.cdqidian.net",
  dev_api4: "https://test.cdqidian.net/itms",
  dev_api5: "https://vitorder-dev.cdqidian.net",
  prod_api: "https://onlyuser-2.cdqidian.net",
  prod_api2: "https://vitcustomer.cdqidian.net",
  prod_api3: "https://vitcalc.cdqidian.net",
  prod_api4: "https://test.cdqidian.net/itms",
  prod_api5: "https://vitorder.cdqidian.net",
  // dev_fs_register: "125.71.214.61:5060",
  dev_fs_register: "zswitch.cdqidian.cn:5060",
  prod_fs_register: "zswitch.cdqidian.cn:5060",
  // dev_fs_wss:"wss://freeswitch-test.cdqidian.net:7443",
  dev_fs_wss: "wss://freeswitch.cdqidian.net",
  prod_fs_wss: "wss://freeswitch.cdqidian.net",
  dev_notice_wss: "wss://notice-test.cdqidian.cn",
  // dev_notice_wss: "ws://192.168.2.110:8009",
  prod_notice_wss: "wss://notice2.cdqidian.cn"
};



// WEBPACK FOOTER //
// ./src/config/url.config.js